module.exports = __webpack_public_path__ + "static/img/safe-icon.5712b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safe-icon.png
// module id = YotV
// module chunks = 1